import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initDevTools } from './utils/devUtils.ts';
import { initTracker } from './utils/track.ts';
import { initSentry } from './utils/sentryUtils.ts';

initDevTools();
initTracker();
initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
